export const BASENAME = "/msil-dashboard"; // don't add '/' at end off BASENAME
export const BASE_URL = "/app/dashboard";
export const BASE_TITLE = " | MSIL Dashboard";

export const BASE_API_ENDPOINT = process.env.REACT_APP_BASE_API_ENDPOINT;
export const KPIs = [
  "Lead Information",
  "Order value",
  "Average number of parts per lead",
  "Login activity",
  "Customer visit report",
  "Location Update Status",
  "Top 5 DSEs",
  "OrderCollectionReport",
  "IwResearch",
  "NoStock",
  "Partskart Login activity",
  "Partskart Order Collection",
];
export const masterData = {
  zone: ["Central", "East", "North", "South", "South East", "West"],
  region: ["Central", "East", "North", "South", "West"],
  regions: [
    { c: ["Central 1", "Central 2", "Central 3", "Central 4"] },
    { e: ["East 1", "East 2", "East 3"] },
    { n: ["North 1", "North 2", "North 3", "North 4"] },
    { s: ["South 1", "South 2", "South 3"] },
    { w: ["West 1", "West 2", "West 3"] },
    { t: ["South East 1", "South East 2"] },
  ],
};

export const zoneCode = (zone) => {
  switch (zone) {
    case "Central":
      return "c";

    case "North":
      return "n";

    case "South":
      return "s";

    case "East":
      return "e";
    case "West":
      return "w";
    case "South East":
      return "t";
    default:
      return "c";
  }
};
export const getZoneFromRegion = (regionCode) => {
  if (regionCode === "c")
    return [
      {
        id: "c",
        name: "Central",
      },
    ];
  else if (regionCode === "e")
    return [
      {
        id: "e",
        name: "East",
      },
    ];
  else if (regionCode === "n")
    return [
      {
        id: "n",
        name: "North",
      },
    ];
  else if (regionCode === "s")
    return [
      {
        id: "s",
        name: "South",
      },
    ];
  else if (regionCode === "t")
    return [
      {
        id: "t",
        name: "South East",
      },
    ];
  else if (regionCode === "w")
    return [
      {
        id: "w",
        name: "West",
      },
    ];
};

export const getZoneName = (zone) => {
  zone = zone.toLowerCase();
  if (zone !== "t1" && zone !== "t2") zone = zone[0];
  switch (zone) {
    case "c":
      return "Central";

    case "n":
      return "North";

    case "s":
    case "t1":
      return "South";

    case "e":
    case "t2":
      return "East";

    case "w":
      return "West";

    default:
      return "Central";
  }
};

export const CONFIG = {
  layout: "vertical", // vertical, horizontal
  subLayout: "", // null, layout-2, layout-2-2, layout-3, layout-4, layout-4-2, layout-6, layout-8
  collapseMenu: false, // mini-menu
  layoutType: "menu-dark", // menu-dark, menu-light, dark
  navIconColor: false,
  headerBackColor: "header-default", // header-default, header-blue, header-red, header-purple, header-lightblue, header-dark
  navBackColor: "navbar-default", // navbar-default, navbar-blue, navbar-red, navbar-purple, navbar-lightblue, navbar-dark
  navBrandColor: "brand-default", // brand-default, brand-blue, brand-red, brand-purple, brand-lightblue, brand-dark
  navBackImage: false, // false, navbar-image-1, navbar-image-2, navbar-image-3, navbar-image-4, navbar-image-5
  rtlLayout: false,
  navFixedLayout: true, // only for vertical layouts
  headerFixedLayout: false, // only for vertical layouts
  boxLayout: false,
  navDropdownIcon: "style1", // style1, style2, style3
  navListIcon: "style1", // style1, style2, style3, style4, style5, style6
  navActiveListColor: "active-default", // active-default, active-blue, active-red, active-purple, active-lightblue, active-dark
  navListTitleColor: "title-default", // title-default, title-blue, title-red, title-purple, title-lightblue, title-dark
  navListTitleHide: false,
  configBlock: true,
  layout6Background:
    "linear-gradient(to right, #A445B2 0%, #D41872 52%, #FF0066 100%)", // used only for pre-layout = layout-6
  layout6BackSize: "", // 'auto' - for background pattern, 'cover' - for background images & used only for pre-layout = layout-6
};

export const getRoleName = (roleId) => {
  switch (+roleId) {
    case 1:
      return "Admin";

    case 2:
      return "HO";

    case 3:
      return "Zonal Manager";

    case 4:
      return "Regional Manager";
    case 5:
      return "DSE";
    case 6:
      return "Distributor";

    default:
      return "Admin";
  }
};

export const getZoneData = (user) => {
  switch (user.zone) {
    case "Central":
      return user.user_count;

    case "South":
      return "HO";

    case "North":
      return "Zonal Manager";

    case "West":
      return "Regional Manager";
    case "East":
      return "DSE";

    default:
      return 0;
  }
};

export const panIndiaZone = (userRole, userFilter) => {
  switch (userRole) {
    case "1":
      return [
        {
          id: "",
          name: "Clear Filter",
        },
        {
          id: "c",
          name: "Central",
        },
        {
          id: "e",
          name: "East",
        },
        {
          id: "n",
          name: "North",
        },
        {
          id: "s",
          name: "South",
        },
        {
          id: "w",
          name: "West",
        },
        {
          id: "t",
          name: "South East",
        },
      ];

    case "3":
      if (userFilter === "c")
        return [
          {
            id: "c",
            name: "Central",
          },
        ];
      else if (userFilter === "e")
        return [
          {
            id: "e",
            name: "East",
          },
        ];
      else if (userFilter === "n")
        return [
          {
            id: "n",
            name: "North",
          },
        ];
      else if (userFilter === "s")
        return [
          {
            id: "s",
            name: "South",
          },
        ];
      else if (userFilter === "t")
        return [
          {
            id: "t",
            name: "South East",
          },
        ];
      else if (userFilter === "w")
        return [
          {
            id: "w",
            name: "West",
          },
        ];
      break;
    case "4":
      return [{ id: userFilter, name: getFullText[userFilter] }];
    default:
      return [];
  }
};

let regionsList = [
  { id: "c1", name: "C1" },
  { id: "c2", name: "C2" },
  { id: "c3", name: "C3" },
  { id: "c4", name: "C4" },
  { id: "e1", name: "E1" },
  { id: "e2", name: "E2" },
  { id: "e3", name: "E3" },
  { id: "n1", name: "N1" },
  { id: "n2", name: "N2" },
  { id: "n3", name: "N3" },
  { id: "n4", name: "N4" },
  { id: "s1", name: "S1" },
  { id: "s2", name: "S2" },
  { id: "s3", name: "S3" },
  { id: "w1", name: "W1" },
  { id: "w2", name: "W2" },
  { id: "w3", name: "W3" },
  { id: "t1", name: "T1" },
  { id: "t2", name: "T2" },
];
export const filterRegionList = (regionName) => {
  return regionsList.filter((region) => region.id === regionName);
};

export const regions = {
  c: [
    { id: "", name: "Clear Filter" },
    { id: "c1", name: "C1" },
    { id: "c2", name: "C2" },
    { id: "c3", name: "C3" },
    { id: "c4", name: "C4" },
  ],
  e: [
    { id: "", name: "Clear Filter" },
    { id: "e1", name: "E1" },
    { id: "e2", name: "E2" },
    { id: "e3", name: "E3" },
  ],
  n: [
    { id: "", name: "Clear Filter" },
    { id: "n1", name: "N1" },
    { id: "n2", name: "N2" },
    { id: "n3", name: "N3" },
    { id: "n4", name: "N4" },
  ],
  s: [
    { id: "", name: "Clear Filter" },
    { id: "s1", name: "S1" },
    { id: "s2", name: "S2" },
    { id: "s3", name: "S3" },
  ],
  w: [
    { id: "", name: "Clear Filter" },
    { id: "w1", name: "W1" },
    { id: "w2", name: "W2" },
    { id: "w3", name: "W3" },
  ],
  t: [
    { id: "", name: "Clear Filter" },
    { id: "t1", name: "T1" },
    { id: "t2", name: "T2" },
  ],
};

export const dealer_codes_list = {
  c1: [
    { id: "Clear Filter", value: "" },
    { id: "DL01	- NORTHEND DISTRIBUTORS", value: "DL01" },
    { id: " DL03 - GAPL AUTOMOTIVE PVT LTD", value: "DL03" },
    { id: "DL04 - AUTO CZARS", value: "DL04" },
    { id: "DL05 - LMC AUTOMOTIVE CO PVT LTD", value: "DL05" },
    { id: "DL07	- MOHAN SPARES PARTS PRIVATE LIMITED", value: "DL07" },
  ],
  c2: [
    { id: "Clear Filter", value: "" },
    { id: "HR03	- ALVA AUTO SPARES PVT LTD", value: "HR03" },
    { id: "HR04	- EMINENT AUTOMOTIVE", value: "HR04" },
    { id: "UP05 -	KASTURI MOTORS", value: "UP05" },
  ],
  c3: [
    { id: "Clear Filter", value: "" },
    { id: "RJ02	- FRIENDS TRADING CORPORATION", value: "RJ02" },
    { id: "RJ04	- HIND AUTOMOTIVE", value: "RJ04" },
    { id: "RJ06	- INDIA AUTOMOTIVES", value: "RJ06" },
  ],
  c4: [
    { id: "Clear Filter", value: "" },
    { id: "MP02	- CITY MOTORS", value: "MP02" },
    { id: "MP03	- N M AUTO PARTS", value: "MP03" },
    { id: "MP05	- P M DISTRIBUTORS", value: "MP05" },
    { id: "MP06	- SHUBH MOTORS", value: "MP06" },
  ],
  e1: [
    { id: "Clear Filter", value: "" },
    { id: "SK01	- MITTAL TRADING CO", value: "SK01" },
    { id: "WB01	- BANSAL MOTOR DISTRIBUTORS", value: "WB01" },
    { id: "WB02	- AUTO SALES", value: "WB02" },
    { id: "WB03	- MITTAL TRADING CO", value: "WB03" },
    { id: "WB04	- GAYATRI ENTERPRISES", value: "WB04" },
  ],
  e2: [
    { id: "Clear Filter", value: "" },
    { id: "BH01 - VIJAY AUTOMOTIVES & AGENCIES", value: "BH01" },
    { id: "BH02	- A.G.P. MARKETING", value: "BH02" },
    { id: "BH03 -	AUTOEDGE TRADERS PVT LTD", value: "BH03" },
    { id: "JH01	- TRIVENI MARKETING", value: "JH01" },
    { id: "JH02 -	NR ENTERPRISES", value: "JH02" },
    { id: "JH03 -	RATTANLALL SPARES", value: "JH03" },
  ],
  e3: [
    { id: "Clear Filter", value: "" },
    { id: "AS01 -	HARNAM MOTOR CO.(MD)", value: "AS01" },
    { id: "AS03	- ALLIED AUTO DISTRIBUTORS", value: "AS03" },
    { id: "AS05	- KASHLIWAL AUTO PVT. LTD.", value: "AS05" },
    { id: "AS06 -	TECHNO MECH", value: "AS06" },
    { id: "AS07	- ALLIED AUTO DISTRIBUTORS", value: "AS07" },
    { id: "MN01	- MANIPUR DIESELS SPARE", value: "MN01" },
    { id: "ML01	- RANI SPARES", value: "ML01" },
    { id: "NL01	- KASHLIWAL ENTERPRISES PVT LTD", value: "NL01" },
  ],
  n1: [
    { id: "Clear Filter", value: "" },
    { id: "UA01	- ASHOKA MOTORS", value: "UA01" },
    { id: "UA02	- BEEKAY DISTRIBUTORS PVT. LTD.", value: "UA02" },
    { id: "UP07	- GOPAL AUTO DISTRIBUTORS", value: "UP07" },
    { id: "UP08	- AUTO ONE", value: "UP08" },
  ],
  n2: [
    { id: "Clear Filter", value: "" },
    { id: "JK01	- PEAKS AUTO CORPORATION", value: "JK01" },
    { id: "JK02	- DURGA TRADERS", value: "JK02" },
    { id: "PB03	- GULZAR MOTOR", value: "PB03" },
    { id: "PB04	- CM AUTOMOBILES PVT.LTD", value: "PB04" },
    { id: "PB05	- KOCHAR SONS", value: "PB05" },
    { id: "PB07	- JACKSON AGENCIES", value: "PB07" },
    { id: "PB08	- RAJA RAM & SONS DISTRIBUTORS", value: "PB08" },
    { id: "PB09	- JACKSON SALES", value: "PB09" },
    { id: "PB10	- WALIA AUTOZONE", value: "PB10" },
  ],
  n3: [
    { id: "Clear Filter", value: "" },
    { id: "UP01	- BEEKAY DISTRIBUTORS PVT. LTD.", value: "UP01" },
    { id: "UP02	- ORIENTAL AUTO SPARES", value: "UP02" },
    { id: "UP03	- KAMAL SALES", value: "UP03" },
    { id: "UP04	- JAI CHANDRA DISTRIBUTORS", value: "UP04" },
  ],
  n4: [
    { id: "Clear Filter", value: "" },
    { id: "HP01	- BALAJI AUTOS", value: "HP01" },
    { id: "HP02	- BEHL AUTOMOBILES PVT LTD", value: "HP02" },
    { id: "HP03	- SWASTIK ENTERPRISE", value: "HP03" },
    { id: "HP04	- BEHL AUTOLINKS PVT LTD", value: "HP04" },
    { id: "HR02	- MAHAMAAN MOTORS", value: "HR02" },
    { id: "HR01	- RAJIV SYNDICATE AUTOZONE PVT. LTD", value: "HR01" },
    { id: "HR05	- SRI SALASAR AUTOMOBILES", value: "HR05" },
  ],
  s1: [
    { id: "Clear Filter", value: "" },
    { id: "TN03	- RAJKRISHNA ADITYA AUTO STORE PVT LTD", value: "TN03" },
    { id: "TN04	- RAJKRISHNA ADITYA AUTO STORE PVT LTD", value: "TN04" },
    { id: "TN07	- ARUNACHAL MOTOR PARTS", value: "TN07" },
    { id: "TN08	- XL AUTO", value: "TN08" },
    { id: "TN09	- SOUTHERN AUTOMOBILES PVT LTD", value: "TN09" },
    { id: "TN10	- RK AGENCIES", value: "TN10" },
    { id: "PY01	- RAJKRISHNA ADITYA AUTO STORE PVT LTD", value: "PY01" },
  ],
  s2: [
    { id: "Clear Filter", value: "" },
    { id: "KA01	- NEMA AUTO SPARES", value: "KA01" },
    { id: "KA02	- ESSARR AUTOMOTIVES", value: "KA02" },
    { id: "KA03	- MAROOR MOTORS", value: "KA03" },
    { id: "KA05	- POPULAR AUTO DEALERS PVT LTD", value: "KA05" },
    { id: "KA04	- SHAKTI AUTO MART", value: "KA04" },
  ],
  s3: [
    { id: "Clear Filter", value: "" },
    { id: "KL01	- SAI SERVICE SPARES AND ACCESSORIES LTD.", value: "KL01" },
    { id: "KL02	- SAI SERVICE SPARES AND ACCESSORIES LTD.", value: "KL02" },
    { id: "KL03	- POPULAR AUTO DEALERS PVT LTD", value: "KL03" },
    { id: "KL04	- POPULAR AUTO DEALERS PVT LTD", value: "KL04" },
  ],
  t1: [
    { id: "Clear Filter", value: "" },
    { id: "AP02	- MAHESH AGENCIES", value: "AP02" },
    { id: "AP03	- ADVANCE AUTO PARTS", value: "AP03" },
    { id: "AP05	- RPB AUTOMOTIVES PRIVATE LIMITED", value: "AP05" },
    { id: "AP07	- ROTEX AUTO PARTS PVT LTD", value: "AP07" },
    { id: "AP09	- RAJDEEP AUTOMOTIVES", value: "AP09" },
  ],
  t2: [
    { id: "Clear Filter", value: "" },
    { id: "CG01	- J.K.AUTOMOBILES", value: "CG01" },
    { id: "CG02	- UDAY CAR SPARES", value: "CG02" },
    { id: "OR01	- RAHUL SPARES PVT.LTD", value: "OR01" },
    { id: "OR03	- UTKAL AUTO ENTERPRISER PVT.LTD", value: "OR03" },
  ],
  w1: [
    { id: "Clear Filter", value: "" },
    { id: "GA01	- GOVIND POY MOTORS", value: "GA01" },
    { id: "MH01	- SAI SERVICE SPARES AND ACCESSORIES PVT LTD", value: "MH01" },
    { id: "MH02	- WESTERN AUTO SPARES & SERVICES CO.", value: "MH02" },
    { id: "MH03	- AMCO SPARES", value: "MH03" },
  ],
  w2: [
    { id: "Clear Filter", value: "" },
    { id: "MH05	- SAI SERVICE SPARES AND ACCESSORIES PVT LTD.", value: "MH05" },
    { id: "MH04	- AUTO ANTARIKSH", value: "MH04" },
    { id: "MH07	- SUDHANSHUS SALES & MARKETING", value: "MH07" },
    { id: "MH09	- AUTO GEMS", value: "MH09" },
  ],
  w3: [
    { id: "Clear Filter", value: "" },
    { id: "GJ01	- JIGAR CARS PVT LTD", value: "GJ01" },
    { id: "GJ02	- SWASTIK MOTORS", value: "GJ02" },
    { id: "GJ03	- SWASTIK MOTORS", value: "GJ03" },
    { id: "GJ04	- ATUL ENTERPRISE", value: "GJ04" },
    { id: "GJ06	- KATARIA AUTO DEALERS LLP", value: "GJ06" },
  ],
};

export const getRegionName = (zone, flag = true) => {
  if (!zone && flag) return regionsList;
  return regions[zone];
};
export const getDealerCodes = (region, flag = true) => {
  if (!region && flag) return dealer_codes_list;
  return dealer_codes_list[region];
};

export const getFullText = {
  c1: "Central 1",
  c2: "Central 2",
  c3: "Central 3",
  c4: "Central 4",

  e1: "East 1",
  e2: "East 2",
  e3: "East 3",

  n1: "North 1",
  n2: "North 2",
  n3: "North 3",
  n4: "North 4",

  s1: "South 1",
  s2: "South 2",
  s3: "South 3",

  w1: "West 1",
  w2: "West 2",
  w3: "West 3",

  t1: "South East 1",
  t2: "South East 2",

  c: "Central",
  e: "East",
  n: "North",
  s: "South",
  t: "South East",
  w: "West",

  Central: "Central",
  East: "East",
  North: "North",
  South: "South",
  "South East": "South East",
  West: "West",
};
export const validatePassword = (value) => {
  const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;
  return regex.test(value);
};
